import { AdminApiSchema } from "@apiUtils/index";
import { ContentCard } from "@narmi/design_system";
import { $adminApi } from "../../../api";
import styles from "./AccountsPanel.module.css";

type Account = AdminApiSchema.components["schemas"]["Account"];

export function AccountsPanel({ userId }: { userId: string }) {
  const { data: accountsData } = $adminApi.useSuspenseQuery("get", "/v2/admin/accounts/", {
    params: {
      query: {
        user: userId,
      },
    },
  });

  return (
    <div className={styles.accountsPanel}>
      {accountsData.results.length
        ? accountsData.results.map((account) => (
            <div key={account.id}>
              <AccountRow account={account} userId={userId} />
            </div>
          ))
        : "This user does not have any accounts."}
    </div>
  );
}

function AccountRow({ account, userId }: { account: Account; userId: string }) {
  return (
    <ContentCard
      kind="button"
      paddingSize="xs"
      onClick={() => window.open(`/users/${userId}/account/${account.id}`, "_blank")}
    >
      <div className={styles.accountRow}>
        <div className={styles.overflowHidden}>{account.name}</div>
        <div className={`${styles.overflowHidden} ${styles.accountNumber}`}>
          {account.account_number}
        </div>
      </div>
    </ContentCard>
  );
}
